// Australian English date formatting helpers.
// All dates in the app go through here so we get consistent "Friday, 16 October 2026" output.

const AU = "en-AU";

/** "Friday, 16 October 2026" — with an explicit comma so the format is consistent across browsers */
export function formatAuDate(isoDate) {
  if (!isoDate) return "";
  try {
    const d = new Date(isoDate + "T00:00:00");
    const weekday = d.toLocaleDateString(AU, { weekday: "long" });
    const rest = d.toLocaleDateString(AU, { day: "numeric", month: "long", year: "numeric" });
    return `${weekday}, ${rest}`;
  } catch { return isoDate; }
}

/** "Fri, 16 Oct 2026" — shorter version for tabs / dense tables */
export function formatAuDateShort(isoDate) {
  if (!isoDate) return "";
  try {
    const d = new Date(isoDate + "T00:00:00");
    const weekday = d.toLocaleDateString(AU, { weekday: "short" });
    const rest = d.toLocaleDateString(AU, { day: "numeric", month: "short", year: "numeric" });
    return `${weekday}, ${rest}`;
  } catch { return isoDate; }
}

/** "16 October 2026" — for chips / captions without weekday */
export function formatAuDateNoWeekday(isoDate) {
  if (!isoDate) return "";
  try {
    return new Date(isoDate + "T00:00:00").toLocaleDateString(AU, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch { return isoDate; }
}

/** Full timestamp: "13/2/2026, 4:23:45 pm AEDT" — for audit trails */
export function formatAuDateTime(isoTs) {
  if (!isoTs) return "";
  try {
    return new Date(isoTs).toLocaleString(AU, {
      day: "numeric", month: "short", year: "numeric",
      hour: "numeric", minute: "2-digit", hour12: true,
    });
  } catch { return isoTs; }
}
